import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "../css/main.css";
import ContributiiImg from "../images/contributii-img.png";
import "../css/main.css";
import CategorySelect from "../components/CategorySelect";
import PretSelect from "../components/PretSelect";
import SortSelect from "../components/SortSelect";

const Magazin = () => {
  return (
    <div>
      <Header />

      <div className="magazin">
        <h1>Descoperă resurse pentru echilibrul tău mental</h1>
        <p>
          Cauți materiale care să te ajute în gestionarea stresului, dezvoltarea
          personală sau îmbunătățirea relațiilor? Aici găsești cărți, jurnale,
          exerciții practice și ghiduri pentru o mai bună înțelegere a
          psihologiei și a stării de bine.
        </p>
        <div className="filter-container">
          <div className="double-row">
            <div className="row">
              <div className="select-container">
                <label>Categorie</label>
                <CategorySelect />
              </div>
              <div className="select-container">
                <label>Pret</label>
                <PretSelect />
              </div>
            </div>
            <div className="row">
              <div className="select-container">
                <label>Sortare</label>
                <SortSelect />
              </div>
            </div>
          </div>
        </div>
        <div className="grid-3">
          <div className="item">
            <div className="image">
              <img src={ContributiiImg} alt="contributii" />
            </div>
            <h2>Caiet personalizat</h2>
            <div className="type">Journal</div>
            <div className="price">€140.00</div>
          </div>
          <div className="item">
            <div className="image">
              <img src={ContributiiImg} alt="contributii" />
            </div>
            <h2>Caiet personalizat</h2>
            <div className="type">Journal</div>
            <div className="price">€140.00</div>
          </div>
          <div className="item">
            <div className="image">
              <img src={ContributiiImg} alt="contributii" />
            </div>
            <h2>Caiet personalizat</h2>
            <div className="type">Journal</div>
            <div className="price">€140.00</div>
          </div>
          <div className="item">
            <div className="image">
              <img src={ContributiiImg} alt="contributii" />
            </div>
            <h2>Caiet personalizat</h2>
            <div className="type">Journal</div>
            <div className="price">€140.00</div>
          </div>
          <div className="item">
            <div className="image">
              <img src={ContributiiImg} alt="contributii" />
            </div>
            <h2>Caiet personalizat</h2>
            <div className="type">Journal</div>
            <div className="price">€140.00</div>
          </div>
          <div className="item">
            <div className="image">
              <img src={ContributiiImg} alt="contributii" />
            </div>
            <h2>Caiet personalizat</h2>
            <div className="type">Journal</div>
            <div className="price">€140.00</div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Magazin;
